import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import { companyInfo, navigation } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviceLinks = [
    { label: 'Technology Consulting', path: '/technology-consulting' },
    { label: 'AI Consulting', path: '/ai-consulting' },
    { label: 'Product Development', path: '/product-development' },
    { label: 'Workforce Solutions', path: '/workforce-solutions' },
  ];

  const companyLinks = [
    { label: 'About Us', path: '/about' },
    { label: 'Client Impact', path: '/client-impact' },
    { label: 'Why TekClap', path: '/why-tekclap' },
    { label: 'Careers', path: '/careers' },
    { label: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-[#1A1A1A] text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <div className="flex items-center gap-2 bg-white rounded-lg p-2">
                <img
                  src={companyInfo.logo}
                  alt={companyInfo.name}
                  className="h-16 w-auto"
                />
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Strategic partner in technology consulting, AI-driven product
              development, and modern workforce solutions.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/tekclap"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F58B23] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-serif">Services</h4>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-[#F58B23] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-serif">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-[#F58B23] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-semibold mb-6 font-serif">Contact</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`mailto:${companyInfo.contact.email}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-[#F58B23] transition-colors text-sm"
                >
                  <Mail className="w-5 h-5 flex-shrink-0" />
                  <span>{companyInfo.contact.email}</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${companyInfo.contact.phone.replace(/-/g, '')}`}
                  className="flex items-center gap-3 text-gray-400 hover:text-[#F58B23] transition-colors text-sm"
                >
                  <Phone className="w-5 h-5 flex-shrink-0" />
                  <span>{companyInfo.contact.phone}</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-gray-400 text-sm">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                  <span>{companyInfo.contact.address}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-6">
            <Link
              to="/privacy-policy"
              className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-use"
              className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
            >
              Terms of Use
            </Link>
            <Link
              to="/equal-opportunity"
              className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
            >
              Equal Opportunity Statement
            </Link>
            <Link
              to="/ai-disclaimer"
              className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
            >
              AI & Services Disclaimer
            </Link>
            <Link
              to="/contact"
              className="text-gray-500 hover:text-gray-300 text-sm transition-colors"
            >
              Contact Us
            </Link>
          </div>
          
          {/* Copyright */}
          <div className="text-center">
            <p className="text-gray-500 text-sm">
              © {currentYear} TekClap. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
